import { render, staticRenderFns } from "./PolicyRule.vue?vue&type=template&id=46ce012a&scoped=true&"
import script from "./PolicyRule.vue?vue&type=script&lang=js&"
export * from "./PolicyRule.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRule.vue?vue&type=style&index=0&id=46ce012a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ce012a",
  null
  
)

export default component.exports